import Vue from 'vue'

import axios from 'axios'
import router from '@/router'
import store from '@/store'

const clientSecret = process.env.VUE_APP_CLIENT_SECRET
const clientId = process.env.VUE_APP_CLIENT_ID

export const refreshToken = (url) => {
  return new Promise((resolve, reject) => {
    try {
      const refreshToken = localStorage.getItem('refresh_token')
      const clientToken = window.btoa(clientId + ':' + clientSecret)
      const params = new URLSearchParams()

      params.append('grant_type', 'refresh_token')
      params.append('refresh_token', refreshToken)

      const headers = {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: `Basic ${clientToken}`,
        },
      }

      return axios
        .post(`${url}/oauth/token`, params, headers)
        .then(({ data }) => {
          localStorage.setItem('refresh_token', data?.refresh_token)
          localStorage.setItem('access_token', data?.access_token)
        })
        .catch(({ response }) => {
          const { status, data } = response

          if (status === 401) {
            store.commit('setIsLoading', false)
            store.commit('setIsToasterOpen', true)
            store.commit(
              'setToasterMessage',
              Vue.i18n.translate('auth.errors.expiredSession')
            )
            router.push('/login')
          }
        })
    } catch ({ response: { data } }) {
      store.commit('setIsLoading', false)
      store.commit('setIsToasterOpen', true)
      store.commit('setToasterMessage', data?.message)
      router.push('/login')
      return reject(error)
    }
  })
}
